var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowInOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.746,
    height: 33.874,
    viewBox: "0 0 38.746 33.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-transbordement-silo",
    transform: "translate(0 1.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-transbordement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-truck",
    "data-name": "Icon fa-solid-truck",
    d: "M28.975,0a2.35,2.35,0,0,1,2.349,2.349V18.012a2.35,2.35,0,0,1-2.349,2.349h-.783a4.7,4.7,0,1,1-9.4,0H12.53a4.7,4.7,0,1,1-9.4,0H1.566a1.566,1.566,0,0,1,0-3.133V11.615A3.134,3.134,0,0,1,2.481,9.4L6.265,5.614A3.133,3.133,0,0,1,8.482,4.7h2.481V2.349A2.35,2.35,0,0,1,13.313,0ZM10.964,7.831H8.482L4.7,11.615v.915h6.265Zm14.879,12.53a2.349,2.349,0,1,0-2.349,2.349A2.349,2.349,0,0,0,25.843,20.362ZM7.831,18.012a2.349,2.349,0,1,0,2.349,2.349A2.349,2.349,0,0,0,7.831,18.012Z",
    transform: "translate(0 7.777)",
    fill: "rgba(139,139,139,0.5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1562",
    "data-name": "Groupe 1562",
    transform: "translate(12.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-left",
    "data-name": "Icon awesome-long-arrow-alt-left",
    d: "M7.389,14.512H24.03a.7.7,0,0,1,.661.728v3.4a.7.7,0,0,1-.661.728H7.389v2.795a1.312,1.312,0,0,1-2.258,1.03L.387,17.969a1.562,1.562,0,0,1,0-2.059l4.743-5.222a1.312,1.312,0,0,1,2.258,1.03Z",
    transform: "translate(0 -1.161)",
    fill: "#fa983a",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-long-arrow-alt-left-2",
    "data-name": "Icon awesome-long-arrow-alt-left",
    d: "M17.3,14.512H.661A.7.7,0,0,0,0,15.24v3.4a.7.7,0,0,0,.661.728H17.3v2.795a1.312,1.312,0,0,0,2.258,1.03L24.3,17.969a1.562,1.562,0,0,0,0-2.059l-4.743-5.222a1.312,1.312,0,0,0-2.258,1.03Z",
    transform: "translate(0 -10.258)",
    fill: "#81e9ae",
    stroke: "#fff",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowInOut);
export default __webpack_public_path__ + "static/media/arrow-in-out.f248c1be4c00708d45024e7ef4f81f6d.svg";
export { ForwardRef as ReactComponent };